import { SaleInvoiceSummaryModel } from './saleInvoiceSummary.model';
import { SaleSummaryModel } from '../../../../api/entity/saleSummary.model';
import { WorkflowTaskSummaryModel } from '../../../../../workflow/task/api/model/common/workflowTaskSummary.model';


export class SaleInvoiceModel {
    summary: SaleInvoiceSummaryModel;
    sale: SaleSummaryModel;
    emailWorkflowTasks: WorkflowTaskSummaryModel[] = [];
}
